import { UploaderValue } from '@xsolla/ui-uploader';

import { uploadMerchantFile } from '../../../../api';
import {
  IMAGE_MAX_FILE_SIZE_BYTES,
  IMAGE_VALID_NAME_REGEX,
  IMAGE_VALID_TYPE_REGEX
} from './constants';

interface UploadErrorMessages {
  sizeError: string;
  uploadError: string;
}

type CreateLogoUploaderReturnType = (file: File) => Promise<UploaderValue>;

export const createLogoUploader = (
  merchantId: number,
  errorMessages: UploadErrorMessages
): CreateLogoUploaderReturnType => {
  return async (file: File): Promise<UploaderValue> => {
    if (!IMAGE_VALID_NAME_REGEX.test(file.name) || !IMAGE_VALID_TYPE_REGEX.test(file.type)) {
      return Promise.reject(new Error(errorMessages.uploadError));
    }

    if (file.size > IMAGE_MAX_FILE_SIZE_BYTES) {
      return Promise.reject(new Error(errorMessages.sizeError));
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await uploadMerchantFile(merchantId, formData);

      return response?.file_url
        ? { filename: '', url: response.file_url }
        : Promise.reject(new Error(errorMessages.uploadError));
    } catch (error) {
      return Promise.reject(new Error(errorMessages.uploadError));
    }
  };
};
